import React, { useEffect, useState } from "react";
import { bankIncomeTableFields } from "./bankincome";

const BankIncomeTable = ({ onObjectReceived, income1TableDataEdit, income2TableDataEdit, income3TableDataEdit, income4TableDataEdit, customerName, isDisbursed }) => {
    const [incomeFields, setIncomeFields] = useState(bankIncomeTableFields);
    const [customerNumberCoop, setCustomerNumberCoop] = useState('');
    const [totalmonthlyPayment, setTotalmonthlyPayment] = useState(0)
    const [countOfMonths, setCountOfMonths] = useState(0)
    const [avragePayout, setAvragePayout] = useState(0)
    const [twelveAvgPayout, setTwelveAvgPayout] = useState(0)
    const [monthlyPaymentDate, setMonthlyPaymentDate] = useState({
        payment1Date: '0',
        payment2Date: '0',
        payment3Date: '0',
    });

    const updateBankIncome = (index, fieldName, value) => {
        const updatedFields = [...incomeFields];
        let totalPayment = 0
        let countMonths = 0
        let avragePayoutTemp = 0
        let twelvwAvragePayoutTemp = 0
        updatedFields[index] = {
            ...updatedFields[index],
            [fieldName]: value
        };
        updatedFields.forEach((value) => {
            value.total = parseInt(value.payment1) + parseInt(value.payment2) + parseInt(value.payment3)
            totalPayment += value.total
            if(value.total>0){
                countMonths++;
            }
        })
        avragePayoutTemp = totalPayment / countMonths
        twelvwAvragePayoutTemp = totalPayment / 12
        setAvragePayout(avragePayoutTemp)
        setTwelveAvgPayout(twelvwAvragePayoutTemp)
        setCountOfMonths(countMonths)
        setTotalmonthlyPayment(totalPayment)
        setIncomeFields(updatedFields);
        countMonths = 0
    };

    useEffect(()=>{
        if(income1TableDataEdit?.tableData !== undefined){
            setIncomeFields(income1TableDataEdit?.tableData)
            setCustomerNumberCoop(income1TableDataEdit?.customerNumberCoop)
            setTotalmonthlyPayment(income1TableDataEdit?.totalmonthlyPayment)
            setCountOfMonths(income1TableDataEdit?.countOfMonths)
            setAvragePayout(income1TableDataEdit?.avragePayout)
            setTwelveAvgPayout(income1TableDataEdit?.twelveAvgPayout)
            setMonthlyPaymentDate(income1TableDataEdit?.monthlyPaymentDate)
        }
        if(income2TableDataEdit?.tableData !== undefined){
            setIncomeFields(income2TableDataEdit?.tableData)
            setCustomerNumberCoop(income2TableDataEdit?.customerNumberCoop)
            setTotalmonthlyPayment(income2TableDataEdit?.totalmonthlyPayment)
            setCountOfMonths(income2TableDataEdit?.countOfMonths)
            setAvragePayout(income2TableDataEdit?.avragePayout)
            setTwelveAvgPayout(income2TableDataEdit?.twelveAvgPayout)
            setMonthlyPaymentDate(income2TableDataEdit?.monthlyPaymentDate)
        }
        if(income3TableDataEdit?.tableData !== undefined){
            setIncomeFields(income3TableDataEdit?.tableData)
            setCustomerNumberCoop(income3TableDataEdit?.customerNumberCoop)
            setTotalmonthlyPayment(income3TableDataEdit?.totalmonthlyPayment)
            setCountOfMonths(income3TableDataEdit?.countOfMonths)
            setAvragePayout(income3TableDataEdit?.avragePayout)
            setTwelveAvgPayout(income3TableDataEdit?.twelveAvgPayout)
            setMonthlyPaymentDate(income3TableDataEdit?.monthlyPaymentDate)
        }
        if(income4TableDataEdit?.tableData !== undefined){
            setIncomeFields(income4TableDataEdit?.tableData)
            setCustomerNumberCoop(income4TableDataEdit?.customerNumberCoop)
            setTotalmonthlyPayment(income4TableDataEdit?.totalmonthlyPayment)
            setCountOfMonths(income4TableDataEdit?.countOfMonths)
            setAvragePayout(income4TableDataEdit?.avragePayout)
            setTwelveAvgPayout(income4TableDataEdit?.twelveAvgPayout)
            setMonthlyPaymentDate(income4TableDataEdit?.monthlyPaymentDate)
        }
    },[income1TableDataEdit,income2TableDataEdit,income3TableDataEdit,income4TableDataEdit])

    useEffect(()=>{
        onObjectReceived({tableData:incomeFields,customerNumberCoop:customerNumberCoop,totalmonthlyPayment:totalmonthlyPayment,countOfMonths:countOfMonths,avragePayout:avragePayout,twelveAvgPayout:twelveAvgPayout,monthlyPaymentDate:monthlyPaymentDate});
        // eslint-disable-next-line
    },[incomeFields,customerNumberCoop,totalmonthlyPayment,countOfMonths,avragePayout,twelveAvgPayout,monthlyPaymentDate])

    const updateMonthlyDate = (fieldName, value) => {
        const updatedMonthlyPaymentDate = {...monthlyPaymentDate}
        updatedMonthlyPaymentDate[fieldName] = value;
        setMonthlyPaymentDate(updatedMonthlyPaymentDate)
    }

    return (
        <section>
            <div className="obligations-container">
                <h3 style={{
                    textAlign: "center",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    marginBottom: "0.5rem",
                    color: "black",
                }}>
                    Monthly Bank Income
                </h3>
                <h3 style={
                    {
                        textAlign: "center",
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        marginBottom: "0.5rem",
                        color: "black",
                    }}>
                    Customer Name - {customerName}
                </h3>
                <br />
                <table className="report-table" style={{margin:"auto"}}>
                    <thead>
                        <tr>
                            <th>Month Count</th>
                            <th>Month</th>
                            <th>Payment 1</th>
                            <th>Payment 2</th>
                            <th>Payment 3</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colSpan="2">
                                Monthly Payment Dates (As per bank Credits)
                            </td>
                            <td>
                                <input
                                    type='text'
                                    style={{
                                        width: "60px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        padding: "2px 4px",
                                        backgroundColor: "#fff",
                                        boxSizing: "border-box",
                                    }}
                                    disabled={isDisbursed}
                                    value={monthlyPaymentDate?.payment1Date}
                                    onChange={(e) => updateMonthlyDate('payment1Date', e.target.value)}
                                />
                            </td>
                            <td>
                                <input
                                    type='text'
                                    style={{
                                        width: "60px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        padding: "2px 4px",
                                        backgroundColor: "#fff",
                                        boxSizing: "border-box",
                                    }}
                                    disabled={isDisbursed}
                                    value={monthlyPaymentDate?.payment2Date}
                                    onChange={(e) => updateMonthlyDate('payment2Date', e.target.value)}
                                />
                            </td>
                            <td>
                                <input
                                    type='text'
                                    style={{
                                        width: "60px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        padding: "2px 4px",
                                        backgroundColor: "#fff",
                                        boxSizing: "border-box",
                                    }}
                                    value={monthlyPaymentDate?.payment3Date}
                                    disabled={isDisbursed}
                                    onChange={(e) => updateMonthlyDate('payment3Date', e.target.value)}
                                />
                            </td>
                            <td></td>
                        </tr>
                        {incomeFields?.map((fields, index) => {
                            return (
                                <tr key={index}>
                                    <td>{fields?.monthCount}</td>
                                    <td>
                                        <input
                                            type='month'
                                            value={fields?.monthState}
                                            onChange={(e) => updateBankIncome(index, 'monthState', e.target.value)}
                                            disabled={isDisbursed}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type='text'
                                            style={{
                                                width: "60px",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                                padding: "2px 4px",
                                                backgroundColor: "#fff",
                                                boxSizing: "border-box",
                                            }}
                                            value={fields?.payment1}
                                            disabled={isDisbursed}
                                            onChange={(e) => updateBankIncome(index, 'payment1', e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type='text'
                                            style={{
                                                width: "60px",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                                padding: "2px 4px",
                                                backgroundColor: "#fff",
                                                boxSizing: "border-box",
                                            }}
                                            value={fields?.payment2}
                                            disabled={isDisbursed}
                                            onChange={(e) => updateBankIncome(index, 'payment2', e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type='text'
                                            style={{
                                                width: "60px",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                                padding: "2px 4px",
                                                backgroundColor: "#fff",
                                                boxSizing: "border-box",
                                            }}
                                            value={fields?.payment3}
                                            disabled={isDisbursed}
                                            onChange={(e) => updateBankIncome(index, 'payment3', e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <p>{fields.total}</p>
                                    </td>
                                </tr>

                            );
                        })}
                        <tr>
                            <td colSpan="5">
                                Total Payments
                            </td>
                            <td>
                                {totalmonthlyPayment}
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="5">
                                COUNT OF MONTHS
                            </td>
                            <td>
                                {countOfMonths}
                            </td>
                        </tr>
                        {/* <tr>
                            <td colSpan="5">
                                12 Months Avg Payout
                            </td>
                            <td>
                                {twelveAvgPayout}
                            </td>
                        </tr> */}
                        <tr>
                            <td colSpan="5">
                                Average Monthly Payout
                            </td>
                            <td>
                                {avragePayout}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    );
};

export default BankIncomeTable;
